/**
 * Lang_DE
 */
export class Lang_DE {
    constructor() {
        /**
         * lang content
         * @private
         */
        this._content = {
            'Mammal Watching · Processing · Analysing': 'Wale beobachten · Verarbeiten · Analysieren',
            'A platform to record, process and analyse marine-mammal sightings around the Canary Islands.': 'Eine Plattform zum Erfassen, Verarbeiten und Analysieren von Sichtungen von Meeressäugern rund um die Kanarischen Inseln.',
            'A project of the association:': 'Ein Projekt des Vereins:',
            'Open source on': 'Open Source auf',
            'currents, biogeochemistry': 'Strömungen, Biogeochemie',
            'chlorophyll-a, salinity, sea-level anomaly': 'Chlorophyll-a, Salzgehalt, Meeresspiegelanomalie',
            'solar radiation / UV, meteorology': 'Sonnenstrahlung / UV, Meteorologie',
            'weather & marine weather': 'Wetter & Seewetter',
            'climate indices (NAO, AMO, …)': 'Klimaindizes (NAO, AMO, …)',
            'depth grid & map tiles': 'Tiefenraster & Kartenkacheln',
            'depth (fallback)': 'Tiefe (Fallback)',
            'earthquakes': 'Erdbeben',
            'live AIS vessel positions': 'Live-AIS-Schiffspositionen',
            'fishing effort': 'Fischereiaufwand',
            'taxonomy / phylogeny': 'Taxonomie / Phylogenie',
            'tree-of-life explorer': 'Lebensbaum-Explorer',
            'base map': 'Basiskarte',
            'relief tiles': 'Relief-Kacheln',
            'external tour bookings': 'externe Tour-Buchungen',
            'The species silhouettes above (shown on the map and in sighting popovers) are from': 'Die Arten-Silhouetten oben (auf der Karte und in den Sichtungs-Popovern) stammen von',
            '© the respective authors (mostly': '© den jeweiligen Autoren (überwiegend',
            '), licensed under': '), lizenziert unter',
            ', CC0 and Public Domain. The full per-file list is in': ', CC0 und Public Domain. Die vollständige Liste pro Datei befindet sich in',
            'Built with AdminLTE 4, Bootstrap 5, OpenLayers, D3/dc.js and the': 'Erstellt mit AdminLTE 4, Bootstrap 5, OpenLayers, D3/dc.js und der',
            ' widget library.': ' Widget-Bibliothek.',
            'Pulled external_tour rows remain in the database as a historical record.': 'Abgerufene external_tour-Zeilen bleiben als historischer Datensatz in der Datenbank.',
            'Historical sightings keep their reference, but the vehicle disappears from operational pickers.': 'Historische Sichtungen behalten ihre Referenz, aber das Fahrzeug verschwindet aus den operativen Auswahllisten.',
            'Historical sightings that reference it keep the link; it disappears from the picker for new sightings. Revive it later from the Edit dialog.': 'Historische Sichtungen, die darauf verweisen, behalten die Verknüpfung; für neue Sichtungen verschwindet sie aus der Auswahl. Später über den Bearbeiten-Dialog wieder aktivierbar.',
            'Access roles': 'Zugriffsrollen',
            'None set': 'Nicht gesetzt',
            'Specie-Name': 'Art-Name',
            'Ott-Id': 'Ott-Id',
            'WoRMS aphia-ID': 'WoRMS aphia-ID',
            'Specie-Group': 'Art-Gruppe',
            'Specie source': 'Art-Quelle',
            'Specie destination': 'Art-Ziel',
            'Specie save success.': 'Art erfolgreich gespeichert.',
            'User save success.': 'Benutzer erfolgreich gespeichert.',
            'Show all': 'Alle anzeigen',
            'Transfer': 'Übertragen',
            'Reset': 'Zurücksetzen',
            'Start Editing': 'Bearbeiten starten',
            'Stop Editing': 'Bearbeiten beenden',
            'Clear Points': 'Punkte löschen',
            '(no species)': '(keine Art)',
            'Click for details': 'Für Details klicken',
            'OSM tiles': 'OSM-Kacheln',
            'Bathymetry': 'Bathymetrie',
            'Relief (ES)': 'Relief (ES)',
            'Weather + waves': 'Wetter + Wellen',
            'Ocean currents': 'Meeresströmungen',
            'Oceanography & climate': 'Ozeanographie & Klima',
            'Seismic': 'Seismik',
            'Maritime traffic': 'Schiffsverkehr',
            'Taxonomy': 'Taxonomie',
            'Base maps': 'Basiskarten',
            'Bottlenose Dolphin': 'Großer Tümmler',
            'Atlantic Spotted Dolphin': 'Atlantischer Fleckendelfin',
            'Striped Dolphin': 'Blau-Weißer Delfin',
            'Common Dolphin': 'Gemeiner Delfin',
            'Rough-Toothed Dolphin': 'Rauzahndelfin',
            'Fraser\'s Dolphin': 'Fraser-Delfin',
            'Risso\'s Dolphin': 'Rundkopfdelfin',
            'Pilot Whale': 'Grindwal',
            'False Killer Whale': 'Kleiner Schwertwal',
            'Orca': 'Orca',
            'Sperm Whale': 'Pottwal',
            'Pygmy Sperm Whale': 'Zwergpottwal',
            'Cuvier\'s Beaked Whale': 'Cuvier-Schnabelwal',
            'Blainville\'s Beaked Whale': 'Blainville-Schnabelwal',
            'Gervais\' Beaked Whale': 'Gervais-Schnabelwal',
            'Northern Bottlenose Whale': 'Nördlicher Entenwal',
            'Humpback Whale': 'Buckelwal',
            'North Atlantic Right Whale': 'Nordkaper',
            'Fin Whale': 'Finnwal',
            'Sei Whale': 'Seiwal',
            'Blue Whale': 'Blauwal',
            'Bryde\'s Whale': 'Brydewal',
            'Minke Whale': 'Zwergwal',
            'Sea Turtle': 'Meeresschildkröte',
            'Chlorophyll-a (mg/m³)': 'Chlorophyll-a (mg/m³)',
            'Chl-a distribution (mg/m³)': 'Chl-a-Verteilung (mg/m³)',
            'SST distribution (°C)': 'SST-Verteilung (°C)',
            'Salinity distribution (PSU)': 'Salzgehalt-Verteilung (PSU)',
            'Sea level anomaly distribution (cm)': 'Verteilung der Meeresspiegelanomalie (cm)',
            'Current speed distribution (m/s)': 'Verteilung der Strömungsgeschwindigkeit (m/s)',
            'Depth distribution (m)': 'Tiefenverteilung (m)',
            'Air temperature distribution (°C)': 'Lufttemperatur-Verteilung (°C)',
            'UV index distribution': 'UV-Index-Verteilung',
            'Wave height distribution (m)': 'Wellenhöhen-Verteilung (m)',
            'Wave period distribution (s)': 'Wellenperioden-Verteilung (s)',
            'Fishing hours distribution (h/day, 25 km)': 'Verteilung der Fischereistunden (h/Tag, 25 km)',
            'Chl-a vs Fishing effort': 'Chl-a vs. Fischereiaufwand',
            'Chl-a — monthly mean': 'Chl-a — Monatsmittel',
            'Top species': 'Top-Arten',
            'Top fishing gear types': 'Top-Fanggerätetypen',
            'Top vessel flags': 'Top-Schiffsflaggen',
            'Load all': 'Alle laden',
            'sightings under the current filter?': 'Sichtungen unter dem aktuellen Filter?',
            'never': 'nie',
            'never run': 'nie ausgeführt',
            'no sightings yet': 'noch keine Sichtungen',
            'No matching tours — relax a picker.': 'Keine passenden Touren — einen Filter lockern.',
            'Alte Daten (manuell erfasst) einblenden': 'Alte Daten (manuell erfasst) einblenden',
            'Unblock IP': 'IP entsperren',
            'Unlock login': 'Login entsperren',
            'Delete Encounter Category': 'Begegnungskategorie löschen',
            'Soft-delete this encounter category?': 'Diese Begegnungskategorie soft-löschen?',
            'Are you sure you want to delete the vehicle?': 'Möchten Sie das Fahrzeug wirklich löschen?',
            ' Dependent services will be stopped too. This affects the live backend.': ' Abhängige Dienste werden ebenfalls gestoppt. Dies betrifft das Live-Backend.',
            'Delete external tour source': 'Externe Tour-Quelle löschen',
            'Delete this source config?': 'Diese Quellen-Konfiguration löschen?',
            'Delete Specie': 'Spezies löschen',
            'Are you sure you want to delete the specie?': 'Möchten Sie die Spezies wirklich löschen?',
            'Load all ...': 'Alle laden ...',
            'Edit': 'Bearbeiten',
            'Save': 'Speichern',
            'Brush a range on the chart to enable actions.': 'Markiere einen Bereich im Diagramm, um Aktionen zu aktivieren.',
            'Use this position': 'Diese Position verwenden',
            'Unlock': 'Entsperren',
            'Unblock': 'Entsperren',
            'Stop': 'Stopp',
            'Start': 'Start',
            'speed (kt)': 'Geschwindigkeit (kn)',
            'Show Map': 'Karte anzeigen',
            'Set rights': 'Rechte setzen',
            'search persons / tour-fid …': 'Personen / Tour-Fid suchen …',
            'search note / recognizable …': 'Notiz / erkennbar suchen …',
            'Scan this code with the MWPA mobile app to sign in.': 'Scanne diesen Code mit der MWPA-App, um dich anzumelden.',
            'Refresh': 'Aktualisieren',
            'Previous tour (no candidate)': 'Vorherige Tour (kein Kandidat)',
            'points / bucket': 'Punkte / Bucket',
            'persons / tour-fid …': 'Personen / Tour-Fid …',
            'Other tour by ID': 'Andere Tour per ID',
            'not set': 'nicht gesetzt',
            'note / recognizable …': 'Notiz / erkennbar …',
            'Next tour (no candidate)': 'Nächste Tour (kein Kandidat)',
            'Name of user': 'Name des Benutzers',
            'Name of specie': 'Name der Spezies',
            'Merge': 'Zusammenführen',
            'Invoke now': 'Jetzt ausführen',
            'Fullname of user': 'Vollständiger Name des Benutzers',
            'Fishing vessels': 'Fischereifahrzeuge',
            'Filter rights …': 'Rechte filtern …',
            'Code expired - click Refresh to generate a new one.': 'Code abgelaufen – auf Aktualisieren klicken, um einen neuen zu erzeugen.',
            'Assign tracks': 'Tracks zuordnen',
            'Assign to tour': 'Zu Tour zuordnen',
            'Sighting saved.': 'Sichtung gespeichert.',
            'Sighting save failed.': 'Speichern der Sichtung fehlgeschlagen.',
            'Sighting delete success.': 'Sichtung gelöscht.',
            'Creating new sightings via this dialog is not supported yet.': 'Das Anlegen neuer Sichtungen über diesen Dialog wird noch nicht unterstützt.',
            'ID is not set!': 'ID ist nicht gesetzt!',
            'Role saved.': 'Rolle gespeichert.',
            'Role save failed.': 'Speichern der Rolle fehlgeschlagen.',
            'Role deleted.': 'Rolle gelöscht.',
            'Role delete failed.': 'Löschen der Rolle fehlgeschlagen.',
            'Rights saved.': 'Rechte gespeichert.',
            'Rights save failed.': 'Speichern der Rechte fehlgeschlagen.',
            'Encounter saved.': 'Begegnung gespeichert.',
            'Encounter deleted.': 'Begegnung gelöscht.',
            'Group save success.': 'Gruppe gespeichert.',
            'Source saved.': 'Quelle gespeichert.',
            'Source deleted.': 'Quelle gelöscht.',
            'Specie delete success.': 'Spezies gelöscht.',
            'Specie merge success.': 'Spezies zusammengeführt.',
            'Area save success.': 'Gebiet gespeichert.',
            'New password is save.': 'Neues Passwort gespeichert.',
            'New pin is save.': 'Neue PIN gespeichert.',
            'IP unblocked.': 'IP entsperrt.',
            'IP was no longer blocked.': 'IP war nicht mehr blockiert.',
            'Login unlocked.': 'Login entsperrt.',
            'Lockout was no longer active.': 'Sperre war nicht mehr aktiv.',
            'Name is required.': 'Name ist erforderlich.',
            'Company shortname is required.': 'Firmen-Kurzname ist erforderlich.',
            'Please select an organisation.': 'Bitte eine Organisation wählen.',
            'Add new Group': 'Neue Gruppe hinzufügen',
            'Edit Group': 'Gruppe bearbeiten',
            'Edit Sighting': 'Sichtung bearbeiten',
            'Delete a sighting': 'Sichtung löschen',
            'Details': 'Details',
            'Change password': 'Passwort ändern',
            'Change mobile app pin': 'Mobile-App-PIN ändern',
            'Tracking points · time / count / speed': 'Tracking-Punkte · Zeit / Anzahl / Geschwindigkeit',
            'Add Encounter': 'Begegnung hinzufügen',
            'Add Group': 'Gruppe hinzufügen',
            'Add role': 'Rolle hinzufügen',
            'Add source': 'Quelle hinzufügen',
            'Add tour': 'Tour hinzufügen',
            'About': 'Über',
            'access': 'Zugriff',
            'active': 'aktiv',
            'Activity': 'Aktivität',
            'Add Encounter Category': 'Begegnungskategorie hinzufügen',
            'Add external tour source': 'Externe Tour-Quelle hinzufügen',
            'Add new tour': 'Neue Tour hinzufügen',
            'Add User': 'Benutzer hinzufügen',
            'admin': 'admin',
            'Admin': 'Admin',
            'App Quick Connect': 'App Quick Connect',
            'Are you sure you want to delete the sighting? Please describe:': 'Möchten Sie die Sichtung wirklich löschen? Bitte beschreiben:',
            'Assign orphan tracks': 'Verwaiste Tracks zuordnen',
            'Avatar': 'Avatar',
            'Base URL': 'Basis-URL',
            'Behaviour co-occurrence': 'Gemeinsames Auftreten von Verhalten',
            'Blacklist': 'Sperrliste',
            'Blacklist (blocked IPs)': 'Sperrliste (blockierte IPs)',
            'Browser': 'Browser',
            'Capacity': 'Kapazität',
            'Coastal current (m/s, ±)': 'Küstenströmung (m/s, ±)',
            'Company shortname': 'Firmen-Kurzname',
            'Count': 'Anzahl',
            'Created by': 'Erstellt von',
            'Credits & licenses': 'Danksagungen & Lizenzen',
            'Data sources': 'Datenquellen',
            'Date / Start': 'Datum / Start',
            'Date / Time': 'Datum / Zeit',
            'Deg / Min (N/S/E/W)': 'Grad / Min (N/S/O/W)',
            'Deleted': 'Gelöscht',
            'Dependencies': 'Abhängigkeiten',
            'Description': 'Beschreibung',
            'Device': 'Gerät',
            'Devices': 'Geräte',
            'disabled': 'deaktiviert',
            'Distance<br>(Miles)': 'Distanz<br>(Meilen)',
            'Distance from pick': 'Distanz zum gewählten Punkt',
            'Distance to nearest coast (nm)': 'Distanz zur nächsten Küste (sm)',
            'Distinct tours the sightings came from — the cluster unit. Sightings on one tour are not independent.': 'Verschiedene Touren, von denen die Sichtungen stammen — die Cluster-Einheit. Sichtungen auf einer Tour sind nicht unabhängig.',
            'Edit Encounter Category': 'Begegnungskategorie bearbeiten',
            'Edit external tour source': 'Externe Tour-Quelle bearbeiten',
            'Edit Species': 'Spezies bearbeiten',
            'Edit User': 'Benutzer bearbeiten',
            'EMail': 'E-Mail',
            'Enabled': 'Aktiviert',
            'Encounter Categories': 'Begegnungskategorien',
            'Encounters': 'Begegnungen',
            'Environmental response (effort-corrected)': 'Umwelt-Reaktion (aufwandskorrigiert)',
            'E. without GPS': 'E. ohne GPS',
            'External tour sources': 'Externe Tour-Quellen',
            'External Tour Sources': 'Externe Tour-Quellen',
            'Filter': 'Filter',
            'First blocked': 'Erstmals blockiert',
            'First / Last seen': 'Erst / Zuletzt gesehen',
            'First seen': 'Erstmals gesehen',
            'from Device': 'von Gerät',
            'Fullname': 'Vollständiger Name',
            'Gi* hotspots': 'Gi*-Hotspots',
            'Groups': 'Gruppen',
            'Hostname': 'Hostname',
            'Hotspots & utilization distribution': 'Hotspots & Nutzungsverteilung',
            'Importance': 'Wichtigkeit',
            'IP': 'IP',
            'Is Admin': 'Ist Admin',
            'Is Disabled': 'Ist deaktiviert',
            'Item': 'Element',
            'Item ids (comma-separated; empty = all)': 'Element-IDs (kommagetrennt; leer = alle)',
            'Last blocked': 'Zuletzt blockiert',
            'Last login': 'Letzte Anmeldung',
            'Last path': 'Letzter Pfad',
            'Last pull': 'Letzter Abruf',
            'Last seen': 'Zuletzt gesehen',
            'Latitude': 'Breitengrad',
            'Lat / Lon (decimal)': 'Breite / Länge (dezimal)',
            'Live AIS Map': 'Live-AIS-Karte',
            'Login lockouts': 'Login-Sperren',
            'Longitude': 'Längengrad',
            'Main group': 'Hauptgruppe',
            'Meeting point': 'Treffpunkt',
            'Merge Species': 'Spezies zusammenführen',
            'name': 'Name',
            'New password': 'Neues Passwort',
            'New pin': 'Neue PIN',
            'No co-occurring behaviours': 'Keine gemeinsam auftretenden Verhalten',
            'No effort data for a seasonal estimate': 'Keine Aufwandsdaten für eine saisonale Schätzung',
            'No effort data for a trend': 'Keine Aufwandsdaten für einen Trend',
            'No tracking points': 'Keine Tracking-Punkte',
            'Ocean & Fishing': 'Ozean & Fischerei',
            'Organisation': 'Organisation',
            'Orphan Tracks': 'Verwaiste Tracks',
            'OS': 'OS',
            'Password': 'Passwort',
            'Password repeat': 'Passwort wiederholen',
            'Persons on boat': 'Personen an Bord',
            'Pick freely (off-route)': 'Frei wählen (abseits der Route)',
            'Pick position': 'Position wählen',
            'Pin': 'PIN',
            'Pin repeat': 'PIN wiederholen',
            'Please pick a boat — AROC requires one file per boat.': 'Bitte ein Boot wählen — AROC benötigt eine Datei pro Boot.',
            'Points': 'Punkte',
            'Position begin': 'Position Beginn',
            'Position end': 'Position Ende',
            'Prices': 'Preise',
            'Provider': 'Anbieter',
            'Provider / Company / Items': 'Anbieter / Firma / Elemente',
            'Red = 50% core / 95% home-range (UD) or significant Gi* hot spot (z≥1.96); blue = Gi* cold spot. Kernel density over all positioned sightings.': 'Rot = 50% Kern / 95% Aktionsraum (UD) oder signifikanter Gi*-Hotspot (z≥1,96); blau = Gi*-Coldspot. Kerndichte über alle positionierten Sichtungen.',
            'Region current (m/s)': 'Regionale Strömung (m/s)',
            'Repeat password': 'Passwort wiederholen',
            'Repeat pin': 'PIN wiederholen',
            'Role': 'Rolle',
            'Roles': 'Rollen',
            'Scheduler': 'Scheduler',
            'Search': 'Suche',
            'search name / description …': 'Name / Beschreibung suchen …',
            'search name / group / ott-id / WoRMS …': 'Name / Gruppe / OTT-ID / WoRMS suchen …',
            'search username / fullname / email …': 'Benutzername / Name / E-Mail suchen …',
            'Seasonality (effort-corrected)': 'Saisonalität (aufwandskorrigiert)',
            '— Select a boat —': '— Boot wählen —',
            'Services': 'Dienste',
            'Share of each metric’s variance that is between-tour rather than within-tour. High values mean sightings cluster by tour — treat them as non-independent (use tour as a random effect in any model).': 'Anteil der Varianz jeder Metrik, der zwischen Touren statt innerhalb einer Tour liegt. Hohe Werte bedeuten, dass Sichtungen nach Tour clustern — behandle sie als nicht unabhängig (Tour als Zufallseffekt im Modell verwenden).',
            'Sighting duration from': 'Sichtungsdauer von',
            'Species silhouettes': 'Spezies-Silhouetten',
            'Target species’ share of ALL sightings per environment bin (background = where surveying happened), with a Wilson 95% band. Unlike the raw histograms above, this is not inflated by how much was surveyed at each value.': 'Anteil der Zielart an ALLEN Sichtungen pro Umwelt-Klasse (Hintergrund = wo erfasst wurde), mit Wilson-95%-Band. Anders als die Roh-Histogramme oben wird dies nicht davon verzerrt, wie viel bei jedem Wert erfasst wurde.',
            'The project': 'Das Projekt',
            'Too few positioned sightings for a spatial estimate (need at least 10).': 'Zu wenige positionierte Sichtungen für eine räumliche Schätzung (mind. 10 nötig).',
            'Too few tours to estimate (need at least two tours per metric).': 'Zu wenige Touren für eine Schätzung (mind. zwei Touren pro Metrik nötig).',
            'too few years for a fit': 'zu wenige Jahre für eine Anpassung',
            'Tour clustering (ICC)': 'Tour-Clustering (ICC)',
            'Tour-Fid': 'Tour-Fid',
            'Tour ID': 'Tour-ID',
            'Tour list': 'Tour-Liste',
            'Tours External': 'Touren extern',
            'Tour start': 'Tour-Start',
            'Tracking points': 'Tracking-Punkte',
            'track pts': 'Track-Pkt',
            'Transfer tracking points': 'Tracking-Punkte übertragen',
            'Type': 'Typ',
            'Unique tours': 'Eindeutige Touren',
            'until': 'bis',
            'User Groups': 'Benutzergruppen',
            'Username': 'Benutzername',
            'User / Organization': 'Benutzer / Organisation',
            'Users': 'Benutzer',
            'Utilization (50/95%)': 'Nutzung (50/95%)',
            'Vehicle / Driver': 'Fahrzeug / Fahrer',
            'Which behaviours were recorded together in the same sighting (ribbon width = shared sightings). Co-occurrence, not a behavioural sequence.': 'Welche Verhalten wurden in derselben Sichtung gemeinsam erfasst (Bandbreite = gemeinsame Sichtungen). Gemeinsames Auftreten, keine Verhaltenssequenz.',
            'Wind speed (m/s)': 'Windgeschwindigkeit (m/s)',
            'Without tracks': 'Ohne Tracks',
            'Yearly SPUE trend': 'Jährlicher SPUE-Trend',
            'title': 'MWPA',
            'login_title': '<b>MWPA</b>',
            'Sighting': 'Sichtung',
            'Tours': 'Touren',
            'Species': 'Spezies',
            'Add sighting': 'Sichtung hinzufügen',
            'Add new sighting': 'Neue Sichtung hinzufügen',
            'Date': 'Datum',
            'Vehicle': 'Fahrzeug',
            'Driver': 'Fahrer',
            'Group-Size': 'Gruppengröße',
            'Time begin': 'Zeit begin',
            'Time end': 'Zeit Ende',
            'Duration': 'Dauer',
            'Location': 'Ort',
            'Encounter': 'Begegnen',
            'Other species': 'Andere Spezies',
            'Add Specie': 'Spezie hinzufügen',
            'List': 'Liste',
            'Map': 'Karte',
            'Analytics': 'Auswertung',
            'Year comparison': 'Jahresvergleich',
            'Export': 'Export',
            'Excel Export': 'Excel-Export',
            'Excel Report': 'Excel-Bericht',
            'Data Page': 'Datenblatt',
            'Columns': 'Spalten',
            'Standard columns': 'Standard-Spalten',
            'Optional columns': 'Optionale Spalten',
            'Select all': 'Alle auswählen',
            'Deselect all': 'Alle abwählen',
            'Coordinate format': 'Koordinaten-Format',
            'Download Excel': 'Excel herunterladen',
            'AROC office report': 'AROC-Bericht',
            'Year': 'Jahr',
            'All years': 'Alle Jahre',
            'External receiver': 'Externer Empfänger',
            'No receivers configured': 'Kein Empfänger konfiguriert',
            'Download report': 'Bericht herunterladen',
            'Generating…': 'Wird erstellt…',
            'Download failed': 'Download fehlgeschlagen',
            'Loading…': 'Lade…',
            'Sighting metadata': 'Sichtungs-Metadaten',
            'Sea depth': 'Seetiefe',
            'Weather (day mean)': 'Wetter (Tagesmittel)',
            'Weather (at sighting hour)': 'Wetter (zur Sichtungs-Stunde)',
            'Id': 'ID',
            'Start of trip': 'Tour-Start',
            'End of trip': 'Tour-Ende',
            'Boat': 'Boot',
            'Skipper': 'Skipper',
            'Observer': 'Beobachter',
            'Wind/Seastate (Beaufort)': 'Wind/Seegang (Beaufort)',
            'Number of animals': 'Anzahl Tiere',
            'Duration from': 'Dauer von',
            'Duration until': 'Dauer bis',
            'Estimation without GPS': 'Schätzung ohne GPS',
            'Distance to nearst coast (nm)': 'Distanz zur Küste (sm)',
            'Juveniles': 'Juvenile',
            'Calves': 'Kälber',
            'Newborns': 'Neugeborene',
            'Behaviour': 'Verhalten',
            'Group structure': 'Gruppen-Struktur',
            'Subgroups': 'Untergruppen',
            'Reaction': 'Reaktion',
            'Frequent behaviours of individuals': 'Häufige Verhaltensweisen einzelner Tiere',
            'Photos taken': 'Fotos gemacht',
            'Recognizable animals': 'Erkennbare Tiere',
            'Other': 'Andere',
            'Other boats present': 'Andere Boote vor Ort',
            'Note': 'Notiz',
            'UUID': 'UUID',
            'Sighting type': 'Sichtungs-Typ',
            'Organization': 'Organisation',
            'Created at': 'Erstellt am',
            'Updated at': 'Aktualisiert am',
            'Tour FID': 'Tour-FID',
            'Sea depth (m)': 'Seetiefe (m)',
            'Depth provider': 'Tiefen-Provider',
            'Sea-surface temperature (Day mean, °C)': 'Wassertemperatur (Tagesmittel, °C)',
            'Air temperature (Day mean, °C)': 'Lufttemperatur (Tagesmittel, °C)',
            'UV index (Day max)': 'UV-Index (Tages-Max)',
            'Wave height (Day mean, m)': 'Wellenhöhe (Tagesmittel, m)',
            'Wave period (Day mean, s)': 'Wellenperiode (Tagesmittel, s)',
            'Wave direction (Day mean, °)': 'Wellenrichtung (Tagesmittel, °)',
            'Sea-surface temperature (At hour, °C)': 'Wassertemperatur (Zur Stunde, °C)',
            'Air temperature (At hour, °C)': 'Lufttemperatur (Zur Stunde, °C)',
            'UV index (At hour)': 'UV-Index (Zur Stunde)',
            'Wave height (At hour, m)': 'Wellenhöhe (Zur Stunde, m)',
            'Wave period (At hour, s)': 'Wellenperiode (Zur Stunde, s)',
            'Wave direction (At hour, °)': 'Wellenrichtung (Zur Stunde, °)',
            'Decimal degrees (e.g. 28.123, -16.456)': 'Dezimalgrad (z. B. 28.123, -16.456)',
            'DMS — Degrees Minutes Seconds (e.g. 28° 07′ 24″ N)': 'DMS — Grad Minuten Sekunden (z. B. 28° 07′ 24″ N)',
            'DM — Degrees Decimal Minutes (e.g. 28° 07.41′ N)': 'DM — Grad Dezimalminuten (z. B. 28° 07.41′ N)',
            'All formats (extra columns per position)': 'Alle Formate (zusätzliche Spalten pro Position)',
            'Species (Top 10)': 'Spezies (Top 10)',
            'Sightings per month': 'Sichtungen pro Monat',
            'Weekday × hour-of-day': 'Wochentag × Stunde',
            'Group size distribution': 'Gruppengrößen-Verteilung',
            'Cumulative sightings': 'Kumulierte Sichtungen',
            'Calendar': 'Kalender',
            'Cumulative trend': 'Kumulierter Verlauf',
            'No sightings under current filter.': 'Keine Sichtungen unter dem aktuellen Filter.',
            'No sightings available for year-on-year comparison.': 'Keine Sichtungen für den Jahresvergleich verfügbar.',
            'No dated sightings available.': 'Keine datierten Sichtungen verfügbar.',
            'sightings analysed.': 'Sichtungen ausgewertet.',
            'sightings across': 'Sichtungen über',
            'year': 'Jahr',
            'years': 'Jahre',
            'Day': 'Tag',
            'Name': 'Name',
            'Country': 'Land',
            'Lon': 'Längengrad',
            'Lat': 'Breitengrad',
            'Province': 'Provinz',
            'Island': 'Insel',
            'Port': 'Hafen',
            'E-Mail': 'E-Mail',
            'Website': 'Webseite',
            'AROC region': 'AROC-Region',
            'AROC number': 'AROC-Nummer',
            'AROC year': 'AROC-Jahr',
            'AROC reference': 'AROC-Referenz',
            'Authorized boats': 'Anzahl autorisierter Boote',
            'Close': 'Schließen',
            'Save changes': 'Änderungen speichern',
            'Semester': 'Halbjahr',
            'Full year': 'Ganzes Jahr',
            '1st semester (Jan–Jun)': '1. Halbjahr (Jan–Jun)',
            '2nd semester (Jul–Dec)': '2. Halbjahr (Jul–Dec)',
            'All boats': 'Alle Boote',
            'Add new Organization': 'Neue Organisation hinzufügen',
            'Edit Organization': 'Organisation bearbeiten',
            'Add Organization': 'Organisation hinzufügen',
            'Generate PDF': 'PDF erzeugen',
            'Combines map, analytics and year comparison on a printable sheet. Uses the browser\'s print dialog — pick "Save as PDF" there.': 'Karte, Auswertung und Jahresvergleich auf einem druckbaren Datenblatt zusammen. Über den Druck-Dialog des Browsers — dort „Als PDF speichern" wählen.',
            'All organizations': 'Alle Organisationen',
            'Vehicles': 'Fahrzeuge',
            'Vehicle Name': 'Fahrzeug-Name',
            'Name of vehicle': 'Name des Fahrzeugs',
            'Add Vehicle': 'Fahrzeug hinzufügen',
            'Edit Vehicle': 'Fahrzeug bearbeiten',
            'Delete Vehicle': 'Fahrzeug löschen',
            'Are you sure you want to delete the vehicle? Historical sightings keep their reference, but the vehicle disappears from operational pickers.': 'Soll das Fahrzeug wirklich gelöscht werden? Historische Sichtungen behalten ihre Referenz, aber das Fahrzeug verschwindet aus den Auswahlboxen.',
            'Vehicle save success.': 'Fahrzeug erfolgreich gespeichert.',
            'Vehicle delete success.': 'Fahrzeug erfolgreich gelöscht.',
            'Please select an organization.': 'Bitte eine Organisation auswählen.',
            'Please enter a vehicle name.': 'Bitte einen Fahrzeug-Namen eingeben.',
            'In use (shown in operational pickers)': 'Aktiv (sichtbar in Auswahlboxen)',
            'Deleted (hidden from admin list)': 'Gelöscht (aus Admin-Liste ausgeblendet)',
            'in use': 'aktiv',
            'not in use': 'nicht aktiv',
            'deleted': 'gelöscht',
            'Status': 'Status',
            'Action': 'Aktion',
            'Delete': 'Löschen',
            'search name / organization …': 'Name / Organisation suchen …',
            'Rebuild movements': 'Bewegungen neu berechnen',
            'Rebuild every sighting\'s movement track now? This may take a while.': 'Bewegungs-Tracks aller Sichtungen jetzt neu berechnen? Das kann eine Weile dauern.',
            'Rebuilding movements…': 'Bewegungen werden neu berechnet…',
            'Rebuild done': 'Neuberechnung fertig',
            'Rebuild failed': 'Neuberechnung fehlgeschlagen',
            'Movement tracks': 'Bewegungs-Tracks',
            'Movement settings': 'Bewegungs-Einstellungen',
            'Lead buffer (minutes before sighting start)': 'Vorlauf-Puffer (Minuten vor Sichtungsbeginn)',
            'Trail buffer (minutes after sighting end)': 'Nachlauf-Puffer (Minuten nach Sichtungsende)',
            'Apply lead/trail around recorded duration (off = strict)': 'Vor-/Nachlauf um aufgezeichnete Dauer anwenden (aus = strikt)',
            'Outlier speed threshold (km/h, segments above are bad)': 'Ausreißer-Geschwindigkeit (km/h, höhere Segmente werden verworfen)',
            'Local timezone for legacy HH:MM (IANA, e.g. Atlantic/Canary)': 'Lokale Zeitzone für Legacy-HH:MM (IANA, z. B. Atlantic/Canary)',
            'Settings saved': 'Einstellungen gespeichert',
            'Load failed': 'Laden fehlgeschlagen',
            'Save failed': 'Speichern fehlgeschlagen',
            // Species Profile — Titel & KPI
            'Profile': 'Profil',
            'Species Profile': 'Spezies-Profil',
            'Period': 'Zeitraum',
            'Sightings': 'Sichtungen',
            'Animals (sum)': 'Tiere (Summe)',
            'Median group': 'Median Gruppengröße',
            'p95 group': 'p95 Gruppengröße',
            // Species Profile — Karten-Titel
            'Sightings per hour-of-day': 'Sichtungen pro Tagesstunde',
            'Composition (sightings reporting …)': 'Zusammensetzung (Sichtungen mit …)',
            'Environment preference': 'Umwelt-Präferenz',
            'Distance to coast (m)': 'Küstenabstand (m)',
            'SST (°C)': 'Wassertemperatur (°C)',
            'Chl-a (mg/m³)': 'Chlorophyll-a (mg/m³)',
            'Behaviour mix': 'Verhaltens-Mix',
            'Reaction to boat': 'Reaktion auf das Boot',
            'Movement signature (derived from SightingMovement)': 'Bewegungs-Signatur (aus SightingMovement)',
            'Spatial distribution': 'Räumliche Verteilung',
            'Dominant heading rose': 'Dominanter Kurs (Windrose)',
            // Species Profile — Movement KPI
            'Sightings w/ movement': 'Sichtungen mit Bewegung',
            'Median avg speed': 'Median ⌀-Geschwindigkeit',
            'Median max speed': 'Median Max-Geschwindigkeit',
            'Median total distance': 'Median Gesamtstrecke',
            // Species Profile — leere Zustände
            'No data': 'Keine Daten',
            'No positions': 'Keine Positionen',
            'No heading data': 'Keine Kurs-Daten',
            'Show description': 'Beschreibung anzeigen',
            // Species Profile — Diagramm-Beschreibungen
            'desc.monthly': 'Anzahl Sichtungen dieser Spezies pro Kalendermonat, summiert über alle Jahre im gewählten Zeitraum. Hilft, saisonales Vorkommen zu erkennen.',
            'desc.hourly': 'Anzahl Sichtungen pro Tagesstunde (anhand der Tour-Start-Stunde). Zeigt tägliche Aktivitätsspitzen der Beobachtungstätigkeit. Hinweis: das ist die Beobachtungszeit, nicht zwingend die tatsächliche Aktivität der Tiere.',
            'desc.group_size': 'Verteilung der erfassten Gruppengrößen (species_count je Sichtung). Lesen als „wie oft wurden X Tiere zusammen angetroffen". Die letzten Buckets fangen einzelne Ausreißer ab.',
            'desc.group_ratios': 'Anteil der Sichtungen, bei denen Jungtiere, Kälber oder Neugeborene gemeldet wurden. Höhere Werte sprechen für Nutzung als Aufzuchts- oder Kinderstuben-Habitat.',
            'desc.env': 'Umweltbedingungen an den Sichtungs-Positionen. Charakterisiert die bevorzugte Habitat-Hülle der Spezies (Wassertiefe, Küstenabstand, Wassertemperatur, Chlorophyll-Konzentration).',
            'desc.behaviour': 'Während der Sichtungen erfasste Verhaltensweisen (aus BehaviouralStates). Eine Sichtung kann mehrere Labels beisteuern; die Top-8 werden gezeigt, der Rest läuft unter „other".',
            'desc.reaction': 'Reaktion der Tiere auf das Beobachtungsboot (aus EncounterCategories). Hilft bei der Bewertung von Beobachtungs-Impact und Habituierung.',
            'desc.movement': 'Bewegungs-Signatur abgeleitet aus SightingMovement — nur Sichtungen mit Track-Segment fließen ein. Geschwindigkeiten sind Mediane in Knoten; die Windrose zeigt die 8-Wege-Kompass-Verteilung des dominanten Kurses je Sichtung.',
            'desc.heatmap': 'Aggregierte Positionen aller Sichtungen im Filter. Jeder Punkt nutzt location_begin; die Heatmap-Intensität markiert Hotspots wiederholter Begegnungen. Es werden bis zu ~2000 Punkte angezeigt.',
            // Species Profile Phase 3 — SPUE, yearly, co-occurrence, pressure, env extra
            'Sightings per tour-hour (SPUE)': 'Sichtungen pro Tour-Stunde (SPUE)',
            'Sightings per year': 'Sichtungen pro Jahr',
            'Co-occurring species (same tour)': 'Mit-vorkommende Spezies (gleiche Tour)',
            'Pressure indicators': 'Druck-Indikatoren',
            'Extended environment (oceanographic)': 'Erweiterte Umwelt (ozeanographisch)',
            'Tour hours': 'Tour-Stunden',
            'tours': 'Touren',
            'Beaufort sea state': 'Beaufort-Seegang',
            'Fishing hours (25 km, day)': 'Fischerei-Stunden (25 km, Tag)',
            'Salinity (PSU)': 'Salzgehalt (PSU)',
            'SLA (cm)': 'SLA (cm)',
            'Current speed (m/s)': 'Strömungs-Geschwindigkeit (m/s)',
            'Wave height (m)': 'Wellenhöhe (m)',
            'UV index': 'UV-Index',
            'desc.spue': 'Aufwand-korrigierte Begegnungsrate: Anzahl Sichtungen pro Tour-Stunde im jeweiligen Monat. Balken = Sichtungen, durchgezogene Linie = Tour-Stunden (rechte Achse), gestrichelte Linie = SPUE. Macht Trends sichtbar, die von der Anzahl Touren verzerrt würden — Standard-Metrik in der Cetacean-Research.',
            'desc.yearly': 'Sichtungen pro Kalenderjahr — komplementär zum Monats-Chart und nützlich für Mehrjahres-Trends. Achtung: Ohne SPUE-Korrektur können Schwankungen reine Effort-Effekte sein.',
            'desc.cooccurrence': 'Top-Spezies, die auf denselben Touren (gleicher tour_fid) wie diese Spezies gesehen wurden. Zählt distinkte Touren — Tour-Doppelzählung pro Spezies ausgeschlossen. Limit 12 Spezies.',
            'desc.pressure': 'Indikatoren für Beobachtungs- und anthropogenen Druck: Beaufort-Seegang während der Sichtung, Anzahl anderer Boote vor Ort (aus „other_vehicle"), kommerzielle Fischerei-Stunden im 25-km-Umkreis am Sichtungstag (GFW).',
            'desc.env_extra': 'Zusätzliche ozeanographische Variablen aus SightingExtended: Salzgehalt (PSU), Meeresspiegel-Anomalie (cm), Strömungs-Geschwindigkeit (m/s), Wellenhöhe (m), UV-Index. Tägliche Mittelwerte.',
            // Cross-species analytics page (Phase 4)
            'Cross-species analytics': 'Spezies-übergreifende Auswertung',
            'Species comparison': 'Spezies-Vergleich',
            'Year × SPUE': 'Jahr × SPUE',
            'SST × group size': 'Wassertemperatur × Gruppengröße',
            'Chlorophyll-a × group size': 'Chlorophyll-a × Gruppengröße',
            'Tour effort × sightings': 'Tour-Aufwand × Sichtungen',
            'Pooled fit': 'Gepoolte Regression',
            '(all species)': '(alle Spezies)',
            'slope': 'Steigung',
            '< min_n (no fit)': '< min_n (kein Fit)',
            'desc.regression.page': 'Vier Streudiagramme über alle Spezies hinweg, jeweils mit einer Regressionslinie pro Spezies (farbig) und einer gepoolten Regression über alle Punkte (schwarz gestrichelt). Wenn die Vorzeichen oder die Steigung von gepoolt und farbig auseinanderlaufen, ist das Simpson-Paradoxon im Spiel — die gepoolte Sicht widerspricht den per-Spezies-Trends. Spezies mit < 10 Punkten werden weiterhin als Streupunkte gezeigt, bekommen aber keine eigene Linie.',
            'desc.reg.year_spue': 'Aufwand-korrigierte Begegnungsrate pro Jahr und Spezies. X = Kalenderjahr, Y = Sichtungen ÷ Tour-Stunden in dem Jahr. Bringt mehrjährige Trends ans Licht, die durch ungleichen Touren-Aufwand verzerrt würden.',
            'desc.reg.sst_groupsize': 'Wassertemperatur am Sichtungstag gegen Gruppengröße. Eine Sichtung = ein Punkt. Klassischer Simpson-Kandidat: Über alle Spezies wirkt SST oft schwach, pro Spezies aber stark — verschiedene Spezies bewohnen verschiedene Temperaturbereiche.',
            'desc.reg.chl_groupsize': 'Chlorophyll-a (Produktivitäts-Proxy) gegen Gruppengröße. Höhere Chl-a-Werte deuten auf produktive Gewässer — testet ob größere Pods produktivere Bereiche nutzen.',
            'desc.reg.effort': 'Monatliche Tour-Stunden gegen Sichtungen derselben Spezies in dem Monat. Eine Sättigungs-Kurve (sub-lineare Steigung) wäre ein Hinweis darauf, dass mehr Aufwand nicht proportional mehr Sichtungen bringt; eine perfekt lineare Beziehung spricht für Aufwand-limitiertes Sampling.',
            // Orphan tracks
            'Orphan track preview': 'Pending-Tracks Vorschau',
            'Delete bucket': 'Bucket löschen',
            'No decodable points in this bucket': 'Keine dekodierbaren Punkte in diesem Bucket',
            // Earthquake admin page (Phase 5)
            'Earthquakes': 'Erdbeben',
            'Events': 'Ereignisse',
            'Period from': 'Zeitraum von',
            'Period to': 'Zeitraum bis',
            'Min magnitude': 'Min. Magnitude',
            'Apply': 'Anwenden',
            'Reload': 'Neu laden',
            'When': 'Wann',
            'Mag': 'Mag.',
            'Depth (km)': 'Tiefe (km)',
            'Place': 'Ort',
            'Source': 'Quelle',
            'Recorrelate all': 'Alle neu korrelieren',
            'Recorrelate done': 'Neu-Korrelation fertig',
            'Recorrelate confirm': 'Alle Sichtungen erneut gegen alle gespeicherten Erdbeben korrelieren? Bei großem Bestand kann das eine Weile dauern — siehe Log.',
            'Impact window': '± Fenster',
            'Impact window hint': 'Welche Sichtungen sind „beeinflusst" — biologisch sinnvolle Zeitfenster pro Erdbeben. Auswahl ≠ „keine" lädt den Impact über alle aktuell gelisteten Erdbeben.',
            'Hide sightings': 'Keine Sichtungen anzeigen',
            '±3 days': '±3 Tage',
            '±7 days': '±7 Tage',
            '±14 days': '±14 Tage',
            'window.hint.off': 'Nur Erdbeben-Liste anzeigen, keine Sichtungs-Korrelationen rendern',
            'window.hint.24h': 'Akute Stressreaktion (Strandungen, P-/S-Wellen-Effekte)',
            'window.hint.3d': 'Kurzfristige Verhaltensänderung',
            'window.hint.7d': 'Mittelfristige Verdrängung / Migrationsverschiebung',
            'window.hint.14d': 'Breit, fängt verzögerte Effekte ein (rauschig)',
            'Impact analysis': 'Auswertung',
            'Impact load failed': 'Impact-Analyse fehlgeschlagen',
            'By species': 'Nach Spezies',
            'By behaviour': 'Nach Verhalten',
            'By encounter category': 'Nach Begegnungskategorie',
            'Hours offset (signed)': 'Zeit-Offset (h, signed)',
            'Window': 'Fenster',
            'days': 'Tage',
            'events': 'Ereignisse',
            'Affected sightings': 'Betroffene Sichtungen',
            'Correlations': 'Korrelationen',
            // Species Profile — seismic exposure
            'Seismic exposure': 'Seismische Exposition',
            'Sightings w/ event': 'Sichtungen mit Beben',
            'Sighting × event pairs': 'Sichtung × Beben (Paare)',
            'Max magnitude': 'Max Magnitude',
            'Median distance': 'Median Abstand',
            'Magnitude': 'Magnitude',
            'Distance to epicenter (km)': 'Abstand zum Epizentrum (km)',
            'Offset (h, +event before sighting)': 'Zeit-Offset (h, +Beben vor Sichtung)',
            'desc.seismic': 'Korrelationen aus der `sighting_seismic`-Tabelle: jede Sichtung dieser Spezies wurde mit Erdbeben im 200-km-Umkreis und ±14 Tagen gepaart. KPI links: Anzahl Sichtungen mit mindestens einem Beben in der Nähe, Gesamtzahl Sichtung × Beben-Paare, stärkste Magnitude, Median-Abstand. Histogramme rechts zeigen die Verteilung von Magnitude, Abstand und Zeit-Offset — positive Offsets = Beben vor Sichtung. Mit positiv schiefer Offset-Verteilung interessant für Verhaltens-Reaktionen.'
        };
    }
    /**
     * getLangCode
     */
    getLangCode() {
        return 'de';
    }
    /**
     * getLangTitle
     */
    getLangTitle() {
        return 'Deutsch';
    }
    /**
     * getCountryCode
     */
    getCountryCode() {
        return 'de';
    }
    /**
     * l
     * @param acontent
     */
    l(acontent) {
        if (this._content[acontent]) {
            return this._content[acontent];
        }
        return null;
    }
    /**
     * getClassName
     */
    getClassName() {
        return 'Lang_DE';
    }
}
